// extracted by mini-css-extract-plugin
export default {"HeaderIcon":"PopupHeaderIcon_HeaderIcon__PNGUo"};